import { http } from './client'
import type { UsageResponse } from '../types/api'

/** GET /api/v1/usage (SDD §36; by member since DEC-196). Admins only. */
export function getUsage(month?: string): Promise<UsageResponse> {
  return http.get(month ? `/api/v1/usage?month=${encodeURIComponent(month)}` : '/api/v1/usage')
}
